import { config } from '~app/config';

import type { HttpClient, HttpClientRequest } from '~shared/api/http-client';
import { httpClient } from '~shared/api/http-client';

import type { DocumentApi } from './document-api';

interface ConstructorParams {
  client: HttpClient;
  host: string;
}

export interface GatewayRequestResponse {
  sessionId: string;
}

export class GatewayDocumentApi implements DocumentApi {
  private client: HttpClient;
  private host: string;

  constructor(params: ConstructorParams) {
    this.client = params.client;
    this.host = params.host;
  }

  generate(applicationId: string): Promise<Blob> {
    return this.makeRequest<Blob>({
      method: 'generate',
      payload: { type: 'LOAN_NOTIFICATION', applicationId },
    });
  }

  private makeRequest<T = unknown>(params: { method: string; payload: any }) {
    const requestParams: HttpClientRequest = {
      httpMethod: 'POST',
      responseType: 'blob',
      type: 'json',
      url: `${this.host}/merchant-portal/api/v1/documents/public/${params.method}`,
      timeout: 60 * 2 * 1000,
      withCredentials: true,
      payload: params.payload,
    };

    return this.client.call<T>(requestParams);
  }
}

export const gatewayDocumentApi = new GatewayDocumentApi({
  client: httpClient,
  host: config.apiHost,
});
